import { defineMessages } from 'react-intl'

const scope = 'app.containers.STRTablePage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Short Term Rental',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Short Term Rentals: {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
